import { Confirm } from '~/scripts/services/modal/modal';

class ConfirmDeleteModal extends Confirm {
	constructor($injector) {
		super($injector);
		this.$translate = $injector.get('$translate');
	}

	/**
	 * @param {string} itemName
	 *
	 * @returns {Promise<boolean>}
	 */
	async open(itemName) {
		return super.open({
			title: this.$translate.instant('common.confirmation'),
			body: `
<span>${this.$translate.instant('modal.click-ok-to-delete')}</span>
<br>
<b>${itemName}</b>
`,
			accept: {
				label: this.$translate.instant('common.delete'),
				type: 'danger',
			},
			cancel: {
				label: this.$translate.instant('common.cancel'),
			},
		});
	}
}

export { ConfirmDeleteModal };
